import React from 'react';
import { ModalBody, ModalHeader } from 'reactstrap';
import Rodal from '../../../components/Rodal/Rodal';
import './DocumetsHistoryPopup.scss';
import { DocumentDetails } from '../../../slices/marketplace/timeline/models/document-details.model';
import OldDocumentsTable from './OldDocumentsTable/OldDocumentsTable';

interface DocumentsHistoryPopupProps {
    oldDocumentDetailsList: DocumentDetails[];
    isVisible: boolean;
    onClose: () => void;
    downloadDocument: (documentId: string) => void;
}

const DocumentsHistoryPopup = (props: DocumentsHistoryPopupProps) => {
    const renderContent = () => {
        return (
            <div>
                {props.oldDocumentDetailsList?.length > 0 ? (
                    <div>
                        <OldDocumentsTable
                            oldDocumentDetailsList={
                                props.oldDocumentDetailsList
                            }
                            downloadDocument={props.downloadDocument}
                        />
                    </div>
                ) : (
                    <div className="w-100 d-flex flex-column align-items-center no-content">
                        <div className="mb-3">No documents to display</div>
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className="documets-history-popup">
            <Rodal
                visible={props.isVisible}
                animation={'slideTop'}
                onClose={props.onClose}
                showMask={true}
                width={600}
                closeOnEsc
                className="modal-old-documets"
                center>
                <ModalHeader className="popup-header">
                    <div className="d-flex align-items-center">
                        <span>Documents History</span>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <div className="bootstrap-table-container">
                        {renderContent()}
                    </div>
                </ModalBody>
            </Rodal>
        </div>
    );
};

export default DocumentsHistoryPopup;
